import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import Grid from '@material-ui/core/Grid';

import { AudioExampleModel, AudioFileModel } from '../../../shared/models/AudioTestModel';
import { SurveyControlRender } from '../../forms/SurveyControl.render';
import { AudioSectionLoopingController } from '../../web-audio/AudioSectionLoopingController';
import { AudioLoading, useAllAudioRefsReady } from '../../web-audio/AudiosLoading';
import { AudioButton, AudioController, useAudioPlayer } from '../../web-audio/AudiosPlayer';

const alphabetList = Array.apply(undefined, Array(26))
  .map((x, y) => String.fromCharCode(y + 65))
  .join('');

export const AbTestItemExampleRender = observer(function (props: { value: AudioExampleModel; active?: boolean; onAudioLoadingChange?: (loading: boolean) => void }) {
  const { value, active, onAudioLoadingChange } = props;
  // This is a custom hook that expose some functions for AudioButton and Controller
  const {
    refs,
    sampleRef,
    activeRef,
    loopRange,
    setLoopRange,
    currentTime,
    handleTimeUpdate,
    handlePlay,
    handlePause,
    handleEnded,
    handleSeek,
    prevPlayedAudio,
  } = useAudioPlayer(value.medias, value.mediaRef, value);
  const allRefs = value.mediaRef ? [...refs, sampleRef] : refs;
  const allAudios = value.mediaRef ? [...value.medias, value.mediaRef] : value.medias;
  const { loading, loadError, progress, sources, retry } = useAllAudioRefsReady(allRefs, allAudios, active !== false);
  const [onTimeUpdate, setOnTimeUpdate] = useState<() => void>();
  // Create empty slots for randomized audios

  useEffect(() => {
    if (active === false) handlePause();
  }, [active]);

  // To over
  const handlePlayOverride: typeof handlePlay = (current: AudioFileModel) => {
    handlePlay(current, value.settings?.alwaysStartFrom0 && current !== prevPlayedAudio ? 0 : undefined);
  };

  return (
    <>
      <AudioLoading showing={loading} error={loadError} progress={progress} onRetry={retry} onLoadingChange={onAudioLoadingChange} />
      <Grid container spacing={2} style={{ display: loading || loadError ? 'none' : 'flex' }}>
        {value.medias.map(
          (v, i) =>
            v && (
              <Grid item key={i}>
                <AudioButton
                  ref={refs[i]}
                  audio={v}
                  source={sources[v.src]}
                  load={active !== false}
                  onPlay={handlePlayOverride}
                  onPause={handlePause}
                  onEnded={handleEnded}
                  onTimeUpdate={() => {
                    handleTimeUpdate();
                    onTimeUpdate?.();
                  }}
                >
                  {value.fields[0]?.options[i] || alphabetList[i]}
                </AudioButton>
                {/*{isDevMode() && <span>{refs[i].current?.currentTime}</span>}*/}
              </Grid>
            )
        )}

        {/*Reference*/}
        {value.mediaRef && (
          <Grid item>
            <AudioButton ref={sampleRef} audio={value.mediaRef} source={sources[value.mediaRef.src]} load={active !== false} onPlay={handlePlayOverride} onPause={handlePause}
                         onEnded={handleEnded} onTimeUpdate={() => {
              handleTimeUpdate();
              onTimeUpdate?.();
            }}>
              Ref
            </AudioButton>
            {/*{isDevMode() && <span>{sampleRef?.current?.currentTime}</span>}*/}
          </Grid>
        )}

        {value.fields?.map((value, i) => (
          <Grid item xs={12} key={i}>
            <SurveyControlRender control={value} />
          </Grid>
        ))}

        <Grid item xs={12}>
          <AudioController
            activeRef={activeRef}
            currentTime={currentTime}
            onSeek={handleSeek}
            disabled={value.settings?.disablePlayerSlider}
          />
          {value.settings?.sectionLooping && (
            <AudioSectionLoopingController
              setTimeUpdate={(f) => setOnTimeUpdate(f)}
              audioRef={activeRef}
              currentTime={currentTime}
              range={loopRange}
              onRangeChange={setLoopRange}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
});
